import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IoBandageOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { userGetProfile } from '../../redux/ducks/UserDucks';
import type { RootReducerType } from '../../redux/reducers/RootReducer.types';
import Logo from '../layout/Navbar/Logo';
import Spinner from '../layout/Spinner/Spinner';

const PartnerCreationSuccess = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onCreatePartnerRequest = useSelector(
    (state: RootReducerType) => state.partner.onCreatePartnerRequest,
  );

  const createPartnerResponse = useSelector(
    (state: RootReducerType) => state.partner.createPartnerResponse,
  );

  useEffect(() => {
    if (createPartnerResponse?.data) {
      dispatch(userGetProfile(true));
    }
  }, [createPartnerResponse, dispatch]);

  const body = useMemo(
    () =>
      createPartnerResponse?.error ? (
        <div className="flex size-full flex-col items-center justify-center gap-0">
          <span className="mb-12 flex w-full flex-col items-center justify-center">
            <IoBandageOutline size={128} />
          </span>
          <span className="mb-8 text-center font-semibold">
            {t('static.join.modal_step_success_error_message')}
          </span>
        </div>
      ) : (
        <div className="flex size-full flex-col items-center justify-center gap-0">
          <span className="mb-2 w-full text-center text-2xl font-bold">
            {t('static.join.modal_step_success_summary_line_a')}
          </span>
          <span className="mb-12 text-center text-xl font-semibold">
            {t('static.join.modal_step_success_summary_line_b', {
              name: t('dynamic.common_company_name'),
            })}
          </span>
          <span className="mb-12 hidden w-full flex-col items-center justify-center sm:flex">
            <Logo size={128} showText={false} />
          </span>
          <span className="text-pretty font-semibold">
            {createPartnerResponse?.data?.approved
              ? t('static.join.modal_step_success_summary_line_c_approved', {
                  name: t('dynamic.common_company_name'),
                })
              : t('static.join.modal_step_success_summary_line_c_pending', {
                  name: t('dynamic.common_company_name'),
                })}
          </span>
        </div>
      ),
    [createPartnerResponse, t],
  );

  return (
    <div className="flex min-h-full min-w-full flex-col items-center justify-center">
      {onCreatePartnerRequest ? <Spinner color="fill-sky-600" /> : body}
    </div>
  );
};

export default PartnerCreationSuccess;
